// extracted by mini-css-extract-plugin
module.exports = {"colors":"'styles/colors.module.css'","SECONDARY_500":"#FF531F","WHITE":"#fff","bannerSection":"styles_bannerSection__buZpD","header":"styles_header__tjpOm"};